"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupChatFromCandid = exports.directChatFromCandid = exports.chatFromCandid = void 0;
const chatFunctions = __importStar(require("../../domain/model/chats"));
const localMessage_1 = require("./localMessage");
const rangeSet_1 = require("./rangeSet");
const timestamp_1 = require("./timestamp");
const userId_1 = require("./userId");
function chatFromCandid(value) {
    if (value.hasOwnProperty("Direct")) {
        return directChatFromCandid(value.Direct);
    }
    else if (value.hasOwnProperty("Group")) {
        return groupChatFromCandid(value.Group);
    }
    else {
        throw new Error("Unable to convert value to Chat");
    }
}
exports.chatFromCandid = chatFromCandid;
function directChatFromCandid(value) {
    return chatFunctions.newConfirmedDirectChat(value.id, userId_1.fromCandid(value.them), timestamp_1.toDate(value.display_date), timestamp_1.toDate(value.last_updated), value.latest_messages.reverse().map(localMessage_1.fromCandid), rangeSet_1.toArray(value.unread_by_me_message_id_ranges), rangeSet_1.toArray(value.unread_by_them_message_id_ranges), value.muted);
}
exports.directChatFromCandid = directChatFromCandid;
function groupChatFromCandid(value) {
    return chatFunctions.newConfirmedGroupChat(value.id, value.subject, value.participants.map(userId_1.fromCandid), timestamp_1.toDate(value.display_date), timestamp_1.toDate(value.last_updated), value.min_visible_message_id, value.latest_messages.reverse().map(localMessage_1.fromCandid), rangeSet_1.toArray(value.unread_by_me_message_id_ranges), rangeSet_1.toArray(value.unread_by_any_message_id_ranges), value.muted);
}
exports.groupChatFromCandid = groupChatFromCandid;
